import Menu from "antd/lib/menu";
import * as React from "react";
import { Link } from "react-router-dom";

export default class NavMenu extends React.Component {
    render() {
        return (
            <Menu
                theme="dark"
                mode="horizontal"
                selectedKeys={[window.location.pathname]}
                style={{ lineHeight: "64px" }}
            >
                <Menu.Item key="/connections">
                    <Link to="/connections">
                        <span>{"Connections"}</span>
                    </Link>
                </Menu.Item>
            </Menu>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu/index.js